export default __webpack_public_path__ + "static/media/bg-badge.08076774.jpg";